'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
interface LoginRequiredSectionProps {
  className?: string;
}
export const LoginRequiredSection = t0 => {
  const $ = _c(13);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full rounded-[40px] bg-B-25", "mobile-tablet:rounded-medium", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex items-center justify-between gap-12 p-40", "mobile-tablet:px-24 mobile-tablet:py-20");
    t3 = ROUTES.LOGIN.withSearchParams({
      searchParams: {
        redirect: window.location.pathname + window.location.search
      }
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src="https://cdn.welfarehello.com/static/login-toggle-icon.png" alt={"\uB85C\uADF8\uC778 \uC544\uC774\uCF58"} width={40} height={40} className="hidden mobile-tablet:block" />;
    t5 = <Image src="https://cdn.welfarehello.com/static/login-toggle-icon-desktop.png" alt={"\uB85C\uADF8\uC778 \uC544\uC774\uCF58"} width={80} height={80} className="mobile-tablet:hidden" />;
    t6 = cn("font-600 !leading-[150%] text-Gray-900 typo-h5", "mobile-tablet:typo-body4");
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-12">{t4}{t5}<p className={t6}>로그인 후<br />이용해 주시기 바랍니다.</p></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SvgChevronright className={cn("hidden size-14 text-B-500", "mobile-tablet:block")} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("inline-flex", "mobile-tablet:hidden");
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CustomLink className={t2} href={t3} aria-label={"\uB85C\uADF8\uC778 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"}>{t7}{t8}<Button className={t9} theme="secondary-fill" dimensions="H40">로그인 하러가기<SvgChevronright className={cn("size-14 text-Gray-white")} /></Button></CustomLink>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t1) {
    t11 = <section className={t1}>{t10}</section>;
    $[11] = t1;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
};